<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 28/8/2020
  -->

<template>
	<div class="pager-table-root flex-container fill-height-container"
	:class="scrollParentClass">

		<div class="files-table-content flex-container fill-height-container"
			 :class="[{'no-header': !hasHeader, 'mb-5': addBottomMargin}]">
			<div
				 :class="contentClass">
				<div v-if="hasData" class="cell-inner py-0">
					<slot name="header"/>
				</div>

					<slot v-if="hasData" name="items-container" :dataArray="dataArray">
						<div :class="itemsContainerClass" ghost-class="ghost">

							<div v-for="(item, index) of dataArray" :key="index + '_' + item.id"
								 :class="itemClass"

								 @click="onRowClicked(item, $event, this)"
								 @dblclick.stop="onRowDoubleClicked(item, $event, this)"
								 @contextmenu.prevent="onRowRightClicked(item, $event, this)">
								<!--							<div :class="{'disabled-row': isRowEnabled(item)}">-->
								<slot name="item" :item="item" :index="index"></slot>
								<!--							</div>-->
							</div>


						</div>
					</slot>
				<slot name="empty-view" v-if="!isLoadingMore && !hasData && (hideEmptyViewFilterFunction() || (!hasFilter || !$slots['empty-view-filter']))"></slot>
				<slot name="empty-view-filter" v-if="!hideEmptyViewFilterFunction() && !isLoadingMore && !hasData && hasFilter && $slots['empty-view-filter']"></slot>


				<div v-if="isLoadingMore" class="row mx-0 justify-content-center p-4"
					 :class="{'relative': hasData}"
					 style="min-height: 80px">
					<LoadingIndicator :is-loading="isLoadingMore"
									  :class="{'no-loading-mask': hasData}"/>
				</div>

			</div>
			<InfiniteLoadingFixed
				ref="infiniteLoader"
				:distance="loadThresholdDistance"
				@infinite="onLoadMore"
				:identifier="infiniteLoadingStateResetter"
				:force-use-infinite-wrapper="scrollContainerSelector"/>


		</div>
	</div>
</template>

<script>

import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
import BaseDataComponent from "@/core/components/BaseDataComponent.vue";
import {getParentByTypeRecursive} from "@/utils/helpers";
import BasePagerView from "@/core/components/Data/BasePagerView.vue";
import {DataFilter} from "@qwoach/firebase-data-manager";
import DbBaseObject from "@shared/DbBaseObject.js";
import InfiniteLoadingFixed from "@/core/components/Data/InfiniteLoadingFixed.vue";
import BaseIdObject from "@shared/BaseIdObject.js";
// import draggable from 'vuedraggable'

export default {
	name: "PagerTable",
	components: {InfiniteLoadingFixed, LoadingIndicator},
	extends: BaseDataComponent,
	props: {
		dataArray: Array,
		isScrollToLoadEnabled: {type: Boolean, default: true},
		showHeader: {type: Boolean, default: true},
		showLastUpdatedColumn: {type: Boolean, default: true},
		showSizeColumn: {type: Boolean, default: true},
		isRowEnabled: {type: Function, default: item => true},
		showRightArrowOnSelect: {type: Boolean, default: false},
        addBottomMargin: {type: Boolean, default: true},
		contentClass: String,
        scrollParentClass: String,
		itemsContainerClass: String,
		itemClass: String,
		hideEmptyViewFilter: [Boolean, Function],
		defaultFilter: DataFilter,
		scrollContainerSelector: {String, default: '.el-main'},
		dataPager: Function,
	},

	data() {
		return {
			isLoadingMore: false,
			hasMore: true,
			hasFilter: false,
			requestedFirstLoad: false,
			clickCount: 0,
			clickTimer: null,
			doubleClickTimeoutMs: 250,
			isRowEnabledCacheData: {},
			loadThresholdDistance: 100,
			infiniteLoadingStateResetter: 0,
			basePagerViewParent: null,
			isForceLoadTriggered: false,
		}
	},

	mounted() {
		this.findBasePagerViewParent()
	},

	methods: {

		async loadData() {
			console.log("PagerTable.loadData")
			this.resetInfiniteLoader()
			this.$nextTick(() => this.forceLoadFirstTime())
			// await this.onLoadMore()
		},

		resetInfiniteLoader() {
			this.infiniteLoadingStateResetter++
		},

		forceLoadFirstTime() {
			// let dst = this.$refs.infiniteLoader.distance
			// this.$refs.infiniteLoader.distance = Number.MAX_VALUE
			// this.$refs.infiniteLoader.attemptLoad()
			// this.$refs.infiniteLoader.distance = dst

			if(this.isForceLoadTriggered){
				return
			}
			this.isForceLoadTriggered = true
			// console.log("forceLoadFirstTime: this.$refs.infiniteLoader = ", this.$refs.infiniteLoader)
			let dst = this.loadThresholdDistance
			this.loadThresholdDistance = Number.MAX_VALUE
			this.$nextTick(() => {
				console.log("forceLoadFirstTime: this.$refs.infiniteLoader = ", this.$refs.infiniteLoader)
				if (this.$refs.infiniteLoader) {
					this.$refs.infiniteLoader.attemptLoad()
				} else {
					this.onLoadMore()
				}
				this.loadThresholdDistance = dst
				this.isForceLoadTriggered = false
			})

		},

		isRowEnabledCache(item) {
			let val = this.isRowEnabled(item)
			let a = 4
			return val
		},

		onLoadingCompleted(hasMore, hasFilter) {
			this.isLoadingMore = false
			this.hasMore = hasMore
			this.hasFilter = hasFilter
            this.notifyLoadingStateChanged()
		},


		async onLoadMore(state) {
			console.log("PagerTable.onLoadMore()11: ", state, this)
			if (this.isLoadingMore) {
				return
			}
			if (this.analyticsProps) {
				let _ = this.$analyticManager.trackEvent("Data portion loaded", this.analyticsPropsMethod())
			}
			this.isLoadingMore = true
            this.notifyLoadingStateChanged()

			let {hasMore, hasFilter} = await this._onLoadMoreInternal()
			this.onLoadingCompleted(hasMore, hasFilter)
			if (state) {
				if (hasMore) {
					state.loaded()
				} else {
					state.complete()
				}
			}
		},

        notifyLoadingStateChanged(){
            this.$emit("onLoadingStateChanged", this.isLoadingMore, this.hasMore)
        },

		async _onLoadMoreInternal() {
			console.log("_onLoadMoreInternal 1")
			let hasMore = true
			let hasFilter = false

			try {
				console.log("_onLoadMoreInternal 2")
				if (this.findListenerByName('onLoadMore')) {
					hasMore = await this.emitPromise("onLoadMore", this)
				} else {
					console.log("_onLoadMoreInternal 3")
					let loadMoreFn = this.basePagerViewParent.onLoadMore
					console.log("_onLoadMoreInternal 4")
					if (typeof loadMoreFn !== "function") {
						console.log("_onLoadMoreInternal 5")
						throw Error("onLoadMore is not implemented in the parent component. Make sure to extend it from BasePagerView or pass @onLoadMore.")
					}
					console.log("_onLoadMoreInternal 6")
					return await loadMoreFn(this)// this.emitPromise("onLoadMore", this)
				}
			} catch (error) {
				console.log("_onLoadMoreInternal 7")
				this.handleError(error)
			}

			return {hasMore, hasFilter}
		},


		analyticsPropsInternal() {
			return {
				category: this.analyticsProps.category || "Pager table"
			}
		},


		onRowRightClicked(item, event) {
			if (this.isRowEnabledCache(item)) {
				this.$emit("onRowRightClicked", item, event, this)
			}
		},
		onRowClicked(item, event) {
			if (this.isRowEnabledCache(item)) {
				this.$emit("onRowClicked", item, event, this)
			}
		},

		onRowDoubleClicked(item, event) {
			if (this.isRowEnabledCache(item)) {
				this.$emit("onRowDoubleClicked", item, event, this)
			}
		},

		findBasePagerViewParent() {
			let targetComponent = BasePagerView
			let res = getParentByTypeRecursive(this.$parent, targetComponent)
			if (res) {
				this.basePagerViewParent = res
				this.basePagerViewParent.pagerTable = this
			} else {
				console.warn(`${this.$options.name} must be placed inside a component that extends ${targetComponent.name}: found in ${this.$parent.$options.name}`)
			}

		},

		hideEmptyViewFilterFunction(){
			let dataPager = this.dataPager
			console.log("PagerTable.hideEmptyViewFilterFunction: dataPager = ", dataPager)
			// if(this.defaultFilter && dataPager.dataFilter === this.defaultFilter){
			// 	return true
			// }
			if(typeof this.hideEmptyViewFilter === "function"){
				return this.hideEmptyViewFilter(dataPager)
			}
			return this.hideEmptyViewFilter
		},

		getElementSearchPredicate(element) {
			let isDbObject = element instanceof BaseIdObject
			return isDbObject ? t => t.id === element.id : t => t === element
		},

		notifyElementDeleted(element) {
			let predicate = this.getElementSearchPredicate(element)
			let index = this.dataArray.findIndex(predicate)
			this.dataArray.splice(index, 1)
		},
		notifyElementUpdated(element) {
			// this.menuInvalidateCache(element)
			let predicate = this.getElementSearchPredicate(element)
			let index = this.dataArray.findIndex(predicate)
			this.dataArray.splice(index, 1, element)
		},
		notifyElementAdded(element) {
			this.dataArray.unshift(element)
		},



	},

	computed: {
		isScrollToLoadDisabled() {
			return !this.isScrollToLoadEnabled || !this.hasMore || this.isLoadingMore
		},

		hasHeader() {
			return false//!!this.$slots.header && !!this.$slots.header[0].children
		},

		hasData() {
			return this.dataArray.length > 0
		},

	}
}
</script>

<style lang="scss">

.pager-table-root {
	//height: 100%;

	overflow: auto;
	min-height: 0;

	.files-table-header {
		height: 50px;
	}

	.files-table-content {
		//height: calc(100% - 50px);
		&.no-header {
			//height: 100%;
		}

		overflow-x: hidden;

		overflow-y: auto;

		.files-table-content-scroll {
		}
	}

	.no-loading-mask {
		.el-loading-mask {
			background: none;
		}
	}


}


</style>


